/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import {HttpClient} from "@angular/common/http";
import {TranslateLoader} from "@ngx-translate/core";
import {Observable, forkJoin, of} from "rxjs";
import {catchError, map, tap} from "rxjs/operators";
import merge from 'deepmerge';

/**
 * @author: Andrew Sheen
 * 
 *  export interface ITranslationResource {
 *   prefix: string;
 *   suffix: string;
 *  }
**/

export class HttpTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private isProd:boolean,
    private resources: Array<string>  ) {}

  public getTranslation(lang: string): Observable<any> {
       
      if ( this.isProd == false )
           this.resources.push('./refresh/assets/i18n/shared');

      const requests = this.resources.map( resource => {
         
            resource = resource + "." + lang + ".json";
            
            return this.http.get(resource).pipe(catchError(res => {
            ///console.error("ERROR:", resource);
            ///console.error(res.message);
            return of({});
            }));
    });

    return forkJoin(requests).pipe( map(response => merge.all(response))
                                   ////,tap(message => console.log(message))
                                  );
  }
}

export class TestTranslateLoader implements TranslateLoader {

      handler:Observable<any>;
      enRes = {};
      frRes = {};
      resource:Object;

      constructor( private list: Array<Object>) {

            for ( let i = 0; i < list.length; i++ ) {
                  
                  let enObj = list[i]['default'];
                  for ( let key in enObj ) {

                        if ( !this.enRes[key] )
                              this.enRes[key] = enObj[key];
                        else console.warn("English key is duplicate",key);
                  }

                  i++;

                  let frObj = list[i]['default'];
                  for ( let key in frObj ) {
                      if ( !this.frRes[key] )
                            this.frRes[key] = frObj[key];
                      else console.warn("French key is duplicate",key);
                  }
            } 
            
            this.handler = new Observable( sub  => {
                 sub.next(this.resource);
            });
      }
  
      public getTranslation(lang: string): Observable<any> {
         
             this.resource = this.enRes;
             if ( lang != 'en' ) this.resource = this.frRes;

             return this.handler; 
      }
}
  